import type { ProfileModuleLike } from './types';

function newEntryId(): string {
  return crypto.randomUUID();
}

function withEntryId<T extends { id?: string }>(entry: T): T {
  return entry.id ? entry : { ...entry, id: newEntryId() };
}

/** Ensures module ids and list entry ids exist for stable matching. */
export function ensureProfileModuleEntryIds<T extends ProfileModuleLike>(
  modules: T[],
): T[] {
  return modules.map((module, index) => {
    const moduleId = String(module.id ?? '') || newEntryId();
    const config = { ...(module.config ?? {}) } as Record<string, unknown>;
    const type = module.type;

    switch (type) {
      case 'socials':
        config.links = ((config.links as Array<{ id?: string }>) ?? []).map(
          (link) => withEntryId(link),
        );
        break;
      case 'contact_info':
        config.items = ((config.items as Array<{ id?: string }>) ?? []).map(
          (item) => withEntryId(item),
        );
        break;
      case 'links':
        config.items = ((config.items as Array<{ id?: string }>) ?? []).map(
          (item) => withEntryId(item),
        );
        break;
      case 'images':
        config.images = ((config.images as Array<{ id?: string }>) ?? []).map(
          (img) => withEntryId(img),
        );
        break;
      case 'files':
        config.files = ((config.files as Array<{ id?: string }>) ?? []).map(
          (file) => withEntryId(file),
        );
        break;
      case 'team_members':
        config.members = ((config.members as Array<{ id?: string }>) ?? []).map(
          (member) => withEntryId(member),
        );
        break;
      default:
        break;
    }

    return {
      ...module,
      id: moduleId,
      order: module.order ?? index,
      config,
    };
  });
}
